<div class="container">
	<div class="row">
		<div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
			@if (errormessage) {
				<div class="message-bad">{{errormessage}}</div>
			}
			<div class="panel">
				<div class="heading">Disable MFA</div>
				<div class="content">
					<p>To disable Multi-Factor Authentication (MFA), you need to enter the code generated by your authenticator app.</p>
					<p>Enter the code below to confirm the action:</p>
					<form>
						<div class="mb-3">
							<label for="mfa_code">MFA Code</label>
							<input [(ngModel)]="mfa_code" name="mfa_code" type="text" class="form-control">
						</div>
						<div class="mb-3">
							<app-action-button submit [action]="DisableMFA" [context]="this" [disabled]="!mfa_code" processing="Disabling..." complete="MFA Disabled">Disable
								MFA</app-action-button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</div>